import { Body4 } from "@/src/components/typography/components/Body";
import { Label4 } from "@/src/components/typography/components/Label";
import { UtilityBadgeType } from "@/src/types";
import Timeline from "../Timeline";

type ActiveBadgeTimelineAnalyticsData = {
  tokenId: string;
  collectionSlug: string;
  tokenName: string;
  contractAddress: string;
};

const ActiveBadgeTimeline = ({
  activeBadges,
  ownedBy,
  analyticsData,
}: {
  activeBadges: UtilityBadgeType[];
  ownedBy: string;
  analyticsData: ActiveBadgeTimelineAnalyticsData;
}) => {
  return (
    <div>
      <Label4>Timeline</Label4>
      <div className="mt-8">
        {activeBadges && activeBadges.length ? (
          activeBadges.map(({ timeline, name, image }, index) => {
            const assetUrl = image.asset.url; // TODO: use createLocalAssetUrl after assets API is finished
            return (
              <div key={name}>
                <Timeline
                  {...timeline}
                  assetUrl={assetUrl}
                  key={name}
                  assetDescription={image.description}
                  ownedBy={ownedBy}
                  analyticsData={analyticsData}
                />
                {index !== activeBadges.length - 1 && (
                  <hr className="my-8 border-gray-800" />
                )}
              </div>
            );
          })
        ) : (
          <Body4 className="mt-6">
            There is no utility available at this time. Feel free to check again
            later for updates.
          </Body4>
        )}
      </div>
    </div>
  );
};

export default ActiveBadgeTimeline;
